import { Injectable } from '@angular/core';
import { User } from '../decorators/user.decorator';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable()
export class PermissionsService {
  @User() public user;

  constructor(private permissionsService: NgxPermissionsService) {
  }

  public init(): void {
    if (this.user && this.user.permissions && this.user.permissions.length > 0 && this.shouldLoadUserPermissions()) {
      const userPermissions = this.user.permissions.map((p) => p.code);
      this.permissionsService.loadPermissions(userPermissions);
    }
  }

  public hasPermission(code: string): boolean {
    return this.user && this.user.permissions && this.user.permissions.filter((p) => p.code === code).length > 0;
  }

  private shouldLoadUserPermissions() {
    const loadedPermissions = Object.keys(this.permissionsService.getPermissions());
    if (loadedPermissions.length !== this.user.permissions.length) {
      return true;
    }
    let res = false;
    this.user.permissions.forEach((p) => {
      if (loadedPermissions.indexOf(p.code) === -1) {
        res = true;
      }
    });
    return res;
  }
}
